module.exports = __webpack_public_path__ + "static/media/sidebar-harmos.848029f5.png";